<template>
  <div class="riseup-icon-item">
    <icon :name="iconName" :icon-name="iconFontName" :size="iconSize" :color="iconColor" :fill="fillIcon" :style="iconStyles"/>
    <span v-if="text">{{ text }}</span>
    <div v-else-if="hasTextSlot">
      <slot name="text"></slot>
    </div>
  </div>
</template>

<script>
import Icon from './Icon.vue';

export default {
  name: 'IconAndText',
  components: {
    Icon,
  },
  props: {
    iconName: {
      type: String,
      required: false,
    },
    iconFontName: {
      type: String,
      required: true,
    },
    iconColor: {
      type: String,
      required: false,
    },
    iconSize: {
      type: String,
      default: '24px',
    },
    fillIcon: {
      type: Boolean,
      default: true,
    },
    text: {
      type: String,
      required: false,
    },
  },
  computed: {
    hasTextSlot() {
      return !!this.$slots.text;
    },
    iconStyles() {
      return {
        marginTop: this.iconFontName ? 2 : undefined,
      };
    },
  },
};
</script>

<style scoped lang="scss">
.riseup-icon-item {
  display: flex;
  padding: 16px 0;
  align-items: flex-start;
  text-align: start;
  img, .icon-rounded, .icon-outlined, .icon-sharp {
    padding-inline-end: 10px; // support rtl and ltr
  }
}
</style>
